import { I18n } from '@/i18n/I18n';

/** How long ago, briefly — just now, 5m ago, 3h ago, 6d ago — and the date once it is more than four weeks back. */
export function relativeTime(at: Date | string, now: Date = new Date()): string {
  const then = new Date(at);
  const seconds = Math.max(0, (now.getTime() - then.getTime()) / 1000);
  if (seconds < 60) return I18n.get('timeJustNow');
  if (seconds < 3600) return I18n.get('timeMinutesAgo', { count: String(Math.floor(seconds / 60)) });
  if (seconds < 86400) return I18n.get('timeHoursAgo', { count: String(Math.floor(seconds / 3600)) });
  if (seconds < 28 * 86400) return I18n.get('timeDaysAgo', { count: String(Math.floor(seconds / 86400)) });
  return then.toLocaleDateString();
}

/** The words of an email's name: `jacob.willoughby+dev@…` is jacob, willoughby. */
function nameParts(email: string): string[] {
  const local = email.split('@')[0].split('+')[0];
  return local.split(/[._-]+/).filter(Boolean);
}

const capital = (word: string) => word.charAt(0).toUpperCase() + word.slice(1);

/** A person named from their email, short enough for a list: `michael.borgholthaus@…` is M. Borgholthaus. */
export function shortName(email: string): string {
  const parts = nameParts(email);
  if (parts.length === 0) return email;
  if (parts.length === 1) return capital(parts[0]);
  return `${parts[0].charAt(0).toUpperCase()}. ${capital(parts[parts.length - 1])}`;
}

/** Two letters for a person's avatar: MB for michael.borgholthaus@…. */
export function initialsOf(email: string): string {
  const parts = nameParts(email);
  if (parts.length === 0) return '?';
  const letters = parts.length === 1 ? parts[0].slice(0, 2) : `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`;
  return letters.toUpperCase();
}
